
import React from "react";
import { CountyIntroduction } from "@/components/nursing-homes/county/CountyIntroduction";
import { CountyFAQSection } from "@/components/nursing-homes/county/CountyFAQSection";
import { CountyAreasSection } from "@/components/nursing-homes/county/CountyAreasSection";
import { CountyNearbySection } from "@/components/nursing-homes/county/CountyNearbySection";

interface ContentSectionsProps {
  countyName: string;
  countySlug: string;
  countyDescription?: string;
  nursingHomeCount: number;
  faqs: { question: string; answer: string }[];
  nearbyCounties: any[];
}

export function ContentSections({
  countyName,
  countySlug,
  countyDescription,
  nursingHomeCount,
  faqs,
  nearbyCounties
}: ContentSectionsProps) {
  return (
    <div className="space-y-8">
      <CountyIntroduction 
        countyName={countyName} 
        nursingHomeCount={nursingHomeCount}
        description={countyDescription || undefined}
      />
      
      <CountyFAQSection 
        countyName={countyName}
        faqs={faqs}
      />
      
      <CountyAreasSection
        countyName={countyName}
        countySlug={countySlug}
      />
      
      <CountyNearbySection 
        countyName={countyName}
        nearbyCounties={nearbyCounties}
      />
    </div>
  );
}
